import { render } from "./Districts.vue?vue&type=template&id=7d39df02"
import script from "./Districts.vue?vue&type=script&lang=js"
export * from "./Districts.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__